// extracted by mini-css-extract-plugin
export default {"contentWrap":"index_contentWrap_AZcNQ"};